import {
  BusinessStatus,
  IBusinessFull,
} from "../../../interfaces/businessFull.interface";
import {
  mapOnlinePaymentStatusLabels,
  mapShift4StatusLabels,
  mapStatusLabels,
} from "./mapStatusLabel";

export type AcquirerColumnKind =
  "rapydValitor" | "rapydNew" | "shift4" | "adyen";

export interface AcquirerColumnStatus {
  label: string;
  color: string;
  empty: boolean;
}

export function resolveAcquirerColumnStatus(
  kind: AcquirerColumnKind,
  record: IBusinessFull
): AcquirerColumnStatus {
  if (kind === "rapydValitor") {
    if (
      record.status === "pendingVerification" &&
      record.rapydOnboardingStatus &&
      record.status !== record.rapydOnboardingStatus
    ) {
      return {
        label:
          record.rapydOnboardingStatus === "verified"
            ? "Approved by Rapyd"
            : "Declined by Rapyd",
        color: record.rapydOnboardingStatus === "verified" ? "green" : "red",
        empty: false,
      };
    }
    const mapped = mapStatusLabels(record.status as BusinessStatus);
    return {
      label: mapped.label,
      color: mapped.label === "Pending Submission" ? "default" : mapped.color,
      empty: !mapped.label,
    };
  }

  if (kind === "rapydNew") {
    const configured = Boolean(
      record.rapydNew?.merchantEwalletId || record.rapydNew?.settlementEwalletId
    );
    return configured
      ? { label: "Configured", color: "green", empty: false }
      : { label: "", color: "default", empty: true };
  }

  if (kind === "shift4") {
    const status = record.shift4?.onboardingStatus;
    const mapped = mapShift4StatusLabels(status);
    return { label: mapped.label, color: mapped.color, empty: !status };
  }

  const adyenStatus = record.adyen?.onboardingStatus;
  if (adyenStatus === "onboardingDisallowed") {
    return { label: "Pricing missing", color: "default", empty: false };
  }
  const online = mapOnlinePaymentStatusLabels(adyenStatus);
  if (!online) {
    return { label: "", color: "default", empty: true };
  }
  return { label: online.label, color: online.color, empty: false };
}
